import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import NavItem from "react-bootstrap/NavItem";
import NavLink from "react-bootstrap/NavLink";

import "./styledTab.scss";

const StyledTab = ({
  icon = null,
  title,
  active = false,
  className = undefined,
  eventKey = false,
  onClick = undefined,
  standalone = false,
  ...furtherProps
}) => (
  <NavItem
    className={classNames(
      "styled-tab",
      className,
      { "styled-tab--standalone": standalone },
    )}
    onClick={onClick}
  >
    <NavLink
      eventKey={eventKey || title}
      className={classNames({ active })}
      {...furtherProps}
    >
      <div className="styled-tab__content">
        {icon && (<div className="styled-tab__icon">{icon}</div>)}
        <div className="styled-tab__title">{title}</div>
      </div>
    </NavLink>
  </NavItem>
);

StyledTab.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  eventKey: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
  standalone: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default StyledTab;
